export default {
  user: {
    isAuthenticated: false,
    data: null,
    isAdmin: false
  }
}
